import React from 'react';
import { RegistrationStatusBadge } from '../CustomerSelector/styles';
import {
    getRegistrationStatusLabel,
    getRegistrationStatusDescription,
} from '../../utils/registrationStatus';
const ellipsisCell = {
    maxWidth: '220px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
};

/** Colunas alinhadas ao DTO CustomerHeader (id, name, document, status). */
export const LEGAL_PERSON_LIST_COLUMNS = [
    {
        header: 'ID',
        accessor: 'id',
        sortable: false,
        render: (item) => (item?.id != null ? String(item.id) : '—'),
    },
    {
        header: 'Nome',
        accessor: 'name',
        sortable: false,
        render: (item) => (
            <div style={ellipsisCell} title={item?.name || undefined}>
                {item?.name || '—'}
            </div>
        ),
    },
    {
        header: 'Documento',
        accessor: 'document',
        sortable: false,
        render: (item) => (
            <div style={{ ...ellipsisCell, maxWidth: '180px' }} title={item?.document || undefined}>
                {item?.document || '—'}
            </div>
        ),
    },
    {
        header: 'Status',
        accessor: 'status',
        sortable: false,
        render: (item) => {
            const desc = getRegistrationStatusDescription(item?.status);
            return (
                <RegistrationStatusBadge $status={item?.status} title={desc || undefined}>
                    {getRegistrationStatusLabel(item?.status)}
                </RegistrationStatusBadge>
            );
        },
    },
];
